import * as React from 'react'
import { SVGProps } from 'react'
import PropTypes from 'prop-types'
interface SVGRProps {
    title?: string;
    titleId?: string;
}
function SvgStar({
    title,
    titleId,
    ...props
}: SVGProps<SVGSVGElement> & SVGRProps) {
    return (
        <svg
            viewBox="0 0 48 48"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path
                d="m23.692 32.87 11.328 8.243-4.336-13.312 11.328-8.061H28.12L23.692 6l-4.427 13.74H5.372L16.7 27.8l-4.336 13.313 11.328-8.244Z"
                stroke="currentColor"
                strokeWidth={3}
                strokeLinejoin="round"
            />
        </svg>
    )
}
SvgStar.propTypes = {
    title: PropTypes.string,
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
    stroke: PropTypes.string,
    color: PropTypes.string,
}
export default SvgStar
